export default __webpack_public_path__ + "static/media/Plaquette_PractiGREEN.d3302e60.pdf";